export default __webpack_public_path__ + "static/media/02_aunt.abb95637.png";